import { ChevronLeft, ChevronRight, ChevronDown } from 'lucide-react';
import { cn } from '../../lib/utils';
import { buttonVariants } from '../button';

export function NavHeader({
    label,
    onPrev,
    onNext,
    disablePrev = false,
    disableNext = false,
    onLabelClick,
    prevLabel = 'Previous',
    nextLabel = 'Next',
    labelClick = 'Change view',
}) {
    return (
        <div className="flex items-center justify-between">
            <button
                type="button"
                onClick={onPrev}
                disabled={disablePrev}
                aria-disabled={disablePrev}
                aria-label={prevLabel}
                className={cn(
                    buttonVariants({ variant: 'ghost' }),
                    'h-7 w-7 p-0 opacity-50 hover:opacity-100 disabled:pointer-events-none disabled:opacity-25'
                )}
            >
                <ChevronLeft className="h-4 w-4" aria-hidden="true" />
            </button>
            {onLabelClick ? (
                <button
                    type="button"
                    onClick={onLabelClick}
                    aria-label={`${label}, ${labelClick}`}
                    className="flex items-center gap-1 text-sm font-medium transition-colors hover:text-foreground/70"
                >
                    <span aria-live="polite" aria-atomic="true">{label}</span>
                    <ChevronDown className="h-3 w-3 opacity-50" aria-hidden="true" />
                </button>
            ) : (
                <span className="text-sm font-medium" aria-live="polite" aria-atomic="true">
                    {label}
                </span>
            )}
            <button
                type="button"
                onClick={onNext}
                disabled={disableNext}
                aria-disabled={disableNext}
                aria-label={nextLabel}
                className={cn(
                    buttonVariants({ variant: 'ghost' }),
                    'h-7 w-7 p-0 opacity-50 hover:opacity-100 disabled:pointer-events-none disabled:opacity-25'
                )}
            >
                <ChevronRight className="h-4 w-4" aria-hidden="true" />
            </button>
        </div>
    );
}
